import React, { useState, useRef, useEffect } from 'react';
import { Col, LicenseFileUploadTextContainer, Row, UploadButtonContainer } from '../../styles';
import { getFileSrcAsBase64 } from '../../../../../../utils/library';
import COLORS from '../../../../../../common/styles/color-pallete';
import { CommonButton } from '@Components';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../store.type';
import { defaultFileSize } from '../../../../../nium-forex/utils/constants';
import {
  getFlagValue,
  isFlagEnabled
} from '../../../../../../redux/actions/flagsmith/flagsmith-main';
import { NIUM_FOREX_FILE_SIZE_LIMIT } from '../../../../../../redux/action-contants';
import { PDF_ICON, UPLOAD_ICON } from '@Images';
interface IUploaderProps {
  warningMessage?: string;
  files: any;
  setFiles: any;
  heading: string;
  subHeading?: string;
  replaceText: string;
  error: boolean;
  uploadIcon?: string;
  uploadText?: string;
  isNiumForexUser?: boolean;
  isNiumForexUserFileSizeError?: boolean;
}

const Uploader = (props: IUploaderProps): React.ReactElement => {
  const {
    files,
    setFiles,
    error,
    uploadIcon,
    uploadText,
    isNiumForexUser = false,
    isNiumForexUserFileSizeError = false
  } = props;
  const fileUploadInputRef = useRef<HTMLInputElement>(null);
  const [fileBase, setFileBase] = useState<string>();
  const [fileError, setFileError] = useState<string>(error ? 'Required' : '');
  const fileSizeLimit =
    (isFlagEnabled(NIUM_FOREX_FILE_SIZE_LIMIT) && getFlagValue(NIUM_FOREX_FILE_SIZE_LIMIT)) ||
    defaultFileSize;
  const handleFileChooserClick = () => {
    //@ts-ignore
    if (files?.length) {
      return null;
    }
    return fileUploadInputRef?.current?.click();
  };

  const handleFileChange = (selectedFiles: React.ChangeEvent<HTMLInputElement>) => {
    if (selectedFiles?.target?.files?.length) {
      const files = [...selectedFiles.target.files];
      const fileList = files;
      setFiles(fileList);
      if (fileList[0]?.type?.includes('image')) {
        getFileSrcAsBase64(fileList[0])?.then((result) => setFileBase(result));
      }
    }
    //@ts-ignore
    if (isNiumForexUser && selectedFiles?.target?.files[0].size > fileSizeLimit) {
      //file size will be in bytes. So to convert the size in MB, we need to divide by square of 1024
      const sizeInMB = (fileSizeLimit || defaultFileSize) / (1024 * 1024);
      setFileError(`File size should not be more than ${sizeInMB}MB`);
    } else {
      setFileError('');
    }
    selectedFiles.target.value = '';
  };

  useEffect(() => {
    if (error) {
      if (isNiumForexUser && isNiumForexUserFileSizeError) {
        //file size will be in bytes. So to convert the size in MB, we need to divide by square of 1024
        const sizeInMB = (fileSizeLimit || defaultFileSize) / (1024 * 1024);
        setFileError(`File size should not be more than ${sizeInMB}MB`);
      } else {
        setFileError('Required');
      }
    } else {
      setFileError('');
    }
    //eslint-disable-next-line
  }, [error]);

  const renderFilePreviews = () => {
    return (
      <UploadButtonContainer onClick={handleFileChooserClick}>
        {files?.length ? (
          <>
            {files[0].type === 'application/pdf' ? (
              <>
                <img width={53} height={53} alt={files[0].name} src={PDF_ICON} />
                <span className="selected-file-name">{`${files[0].name}`}</span>
              </>
            ) : (
              <img className="image-file" alt={files[0].name} src={fileBase} />
            )}
          </>
        ) : (
          <>
            <img src={uploadIcon ? uploadIcon : UPLOAD_ICON} alt="upload-front" />
            <CommonButton text={uploadText || 'Upload'} type="link" />
          </>
        )}
      </UploadButtonContainer>
    );
  };

  return (
    <div>
      <Row padding={[23, 0, 0, 0]}>
        <Col width={336}>
          <div>
            <LicenseFileUploadTextContainer textColor={COLORS.black}>
              <span className="__heading">{props?.heading}</span>
              <span className="__description">{props?.subHeading}</span>
            </LicenseFileUploadTextContainer>
            <div className="div-160">
              <input
                type="file"
                id="bank-verification-file"
                ref={fileUploadInputRef}
                accept=".pdf, .jpg, .jpeg, .png"
                onChange={handleFileChange}
              />
              {renderFilePreviews()}
              {!isNiumForexUser && files?.length && (
                <div className="replace-text" onClick={() => fileUploadInputRef?.current?.click()}>
                  {props?.replaceText}
                </div>
              )}
            </div>
          </div>
          {!isNiumForexUser && <span className="error-msg">{fileError}</span>}
          {isNiumForexUser && (
            <div className="nium-forex-file-size-error-container">
              <span className="error-msg">{fileError}</span>
              {files?.length && (
                <div className="replace-text" onClick={() => fileUploadInputRef?.current?.click()}>
                  {props?.replaceText}
                </div>
              )}
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
};

function mapStateToProps(reduxState: IStore) {
  const {
    rootReducer: {
      niumForexReducer: { isNiumForexUser }
    }
  } = reduxState;

  return { isNiumForexUser };
}
export default connect<any, any, any, IStore>(mapStateToProps, {})(Uploader);
